import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '@environment';

@Injectable({ providedIn: 'root' })
export class CookieService {
    private domainName;
    private isBrowser;
    private path = '/';

    constructor(@Inject(PLATFORM_ID) private platformId: any) {
        this.isBrowser = isPlatformBrowser(this.platformId);

        if (environment.isLocalhost) {
            this.domainName = '';
        } else {
            this.domainName = 'socialboards.com';
        }
    }

    public setCookie(name, value, expiresOption?) {
        const options = this.getCookieOptions(expiresOption);

        value = encodeURIComponent(value);

        let updatedCookie = name + '=' + value;

        // tslint:disable-next-line:forin
        for (const propName in options) {
            if (Object.prototype.hasOwnProperty.call(options, propName)) {
                updatedCookie += '; ' + propName;

                const propValue = options[propName];
                if (propValue !== true) {
                    updatedCookie += '=' + propValue;
                }
            }
        }

        if (this.isBrowser) {
            document.cookie = updatedCookie;
        }
    }

    deleteCookie(name: string, path = '/', domainName?) {
        const date = new Date();

        // Set it expire in -1 days
        date.setTime(date.getTime() + -1 * 24 * 60 * 60 * 1000);

        if (!domainName) {
            domainName = this.domainName;
        }
        // Set it
        if (this.isBrowser) {
            document.cookie =
                name +
                '=; expires=' +
                date.toUTCString() +
                '; path=' +
                path +
                (domainName ? '; domain=' + domainName : '');
        }
    }

    deleteCookieByNameBegining(nameBegining: string) {
        if (this.isBrowser) {
            const cookies = document.cookie.split(';');

            for (const cookie of cookies) {
                const eqPos = cookie.indexOf('=');
                const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;

                if (name && name.indexOf(nameBegining) < 2 && name.indexOf(nameBegining) >= 0) {
                    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
                }
            }
        }
    }

    deleteGoogleAnalyticsCookies(path: string) {
        const allCookies = document.cookie.split(';');
        const gaCookiesNamesList = ['_ga', '_gid', '_gat'];

        let domainName: string;
        if (window.location.hostname === 'localhost') {
            domainName = 'localhost';
        } else {
            domainName = 'socialboards.com';
        }

        allCookies.forEach((cookie) => {
            const name = cookie.split('=')[0].trim();
            for (const gaCookieName of gaCookiesNamesList) {
                if (name.startsWith(gaCookieName)) {
                    this.deleteCookie(name, '/', domainName);
                    this.deleteCookie(name, path, domainName);
                }
            }
        });
    }

    getCookie(name: string) {
        if (this.isBrowser) {
            const matches = document.cookie.match(
                new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\\\+^])/g, '\\$1') + '=([^;]*)'),
            );
            return matches ? decodeURIComponent(matches[1]) : undefined;
        }
        return undefined;
    }

    getExpirationDate(): string {
        const expirationDate = new Date();
        expirationDate.setFullYear(expirationDate.getFullYear() + 1);

        return expirationDate.toUTCString();
    }

    private getCookieOptions(expiresOption?): any {
        const cookieOptions = {
            path: this.path,
            expires: expiresOption || this.getExpirationDate(),
        };

        if (environment.isLocalhost) {
            cookieOptions['domain'] = '';
        } else {
            cookieOptions['domain'] = 'socialboards.com';
            cookieOptions['SameSite'] = 'None';
            cookieOptions['Secure'] = true;
        }

        return cookieOptions;
    }
}
